import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import chendur from "../../assets/clientLogos/Chendur.png";
import cqf from "../../assets/clientLogos/CQF.png";
import dotzen from "../../assets/clientLogos/DotZen.png";
import gowsan from "../../assets/clientLogos/Gowsan.png";
import kalirajiasacademy from "../../assets/clientLogos/KalirajIASAcademy.jpg";
import kasiram from "../../assets/clientLogos/Kasiram.png";
import lakshana from "../../assets/clientLogos/Lakshana.png";
import mildanaturals from "../../assets/clientLogos/Milda_Naturals_Logo_New.png";
import rajusclasses from "../../assets/clientLogos/Raju's Classes.png";
import raysofflix from "../../assets/clientLogos/RaysOfFlix.png";
import rcm from "../../assets/clientLogos/RotaryClubOfMadras.png";
import samporto from "../../assets/clientLogos/Samporto.png";
import selvasiasacademy from "../../assets/clientLogos/Selva's_IAS_Academy_Logo.png";
import sreekrishnaplayschool from "../../assets/clientLogos/SreeKrishnaPlaySchool.png";
import twiwatches from "../../assets/clientLogos/TWI Watches.jpeg";
import twinstarindustries from "../../assets/clientLogos/Twinstar.png";
import cbcid from "../../assets/clientLogos/CBCID.jpg";
import arabianmandhi from "../../assets/clientLogos/Arabian Mandhi.jpg";
import ariesdec from "../../assets/clientLogos/Aries Dec Logo.png";
import brainmask from "../../assets/clientLogos/Brain Mask.jpg";
import deltaconstructions from "../../assets/clientLogos/Delta Constructions.jpeg";
import digitalbharathiacademy from "../../assets/clientLogos/Digital Bharathi Academy.jpg";
import fhf from "../../assets/clientLogos/FHF.png";
import oceanfloralbouquets from "../../assets/clientLogos/Ocean Floral Bouquets.png";
import peacebusinessconsulting from "../../assets/clientLogos/PEACE BUSINESS CONSULTING.jpg";
import ssbt from "../../assets/clientLogos/SSBT LOGO.png";
import vrcreativekids from "../../assets/clientLogos/VR Creative Kids.jpeg";

const brands = [
  cbcid,
  chendur,
  cqf,
  dotzen,
  gowsan,
  kalirajiasacademy,
  kasiram,
  lakshana,
  mildanaturals,
  rajusclasses,
  raysofflix,
  rcm,
  samporto,
  selvasiasacademy,
  sreekrishnaplayschool,
  twiwatches,
  twinstarindustries,
  arabianmandhi,
  ariesdec,
  brainmask,
  deltaconstructions,
  digitalbharathiacademy,
  fhf,
  oceanfloralbouquets,
  peacebusinessconsulting,
  ssbt,
  vrcreativekids,
];

const allClients = [
  { name: "Gowsan Overseas Educational Consultancy", logo: gowsan },
  { name: "Selvas IAS Academy", logo: selvasiasacademy },
  { name: "Kasiram Overseas Educational Consultancy", logo: kasiram },
  { name: "Samporto Freight Forwarding", logo: samporto },
  { name: "Rays of Flix", logo: raysofflix },
  { name: "Delta Construction", logo: deltaconstructions },
  { name: "TWI Watches", logo: twiwatches },
  { name: "Chennai Quiz Factory", logo: cqf },
  { name: "Twin Star Industry", logo: twinstarindustries },
  { name: "Ocean Floral & Bouquet", logo: oceanfloralbouquets },
  { name: "Peace Business Consulting", logo: peacebusinessconsulting },
  { name: "Kaliraj IAS Academy", logo: kalirajiasacademy },
  { name: "Digital Bharathi Academy", logo: digitalbharathiacademy },
  { name: "VR Creative Kids School", logo: vrcreativekids },
  { name: "Sri Sabarivasan Bakthaseva Trust", logo: ssbt },
  { name: "Ariesdec", logo: ariesdec },
  { name: "Javika Therapy", logo: null },
  { name: "Chendur", logo: chendur },
  { name: "DotZen", logo: dotzen },
  { name: "Lakshana", logo: lakshana },
  { name: "Milda Naturals", logo: mildanaturals },
  { name: "Raju's Classes", logo: rajusclasses },
  { name: "Rotary Club Of Madras", logo: rcm },
  { name: "Sree Krishna Play School", logo: sreekrishnaplayschool },
  { name: "Arabian Mandhi", logo: arabianmandhi },
  { name: "Brain Mask", logo: brainmask },
  { name: "FHF", logo: fhf },
  { name: "CBCID", logo: cbcid },
];

export default function ClientTestimonials() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // Stop body scroll when modal is open
  React.useEffect(() => {
    if (isPopupOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    }
  }, [isPopupOpen]);

  return (
    <>
      <section className="bg-gray-50 py-16 px-6 md:px-12 lg:px-24">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <hr className="mb-6 border-gray-200" />
          <p className="text-sm font-medium border border-gray-200 rounded-full px-2 py-1 text-gray-600 ml-[100px] mb-4 inline-block">Our Clients</p>
          <h2 className="text-3xl md:text-5xl text-center font-serif font-medium text-gray-900 mb-6 leading-snug">
            Trusted by ambitious leaders and forward-thinking
            organizations.
          </h2>
          <p className="text-center text-gray-600 text-lg mx-auto max-w-3xl mb-12">
            We’ve partnered with diverse clients - from startups and institutions
            to industrial companies - delivering impactful digital and software
            solutions that drive results.
          </p>

          {/* Smooth Marquee Section */}
          <section className="py-12 bg-[#f7f5f2]">
            <div className="max-w-7xl mx-auto px-4 text-center">
              <h2 className="text-sm uppercase text-gray-500 tracking-widest mb-4">
                Trusted by the world’s best companies
              </h2>

              {/* Marquee Container */}
              <div className="overflow-hidden relative">
                <div className="flex gap-10 md:gap-16 animate-marquee">
                  {[...Array(2)].map((_, index) => (
                    <div key={index} className="flex gap-10 md:gap-16 shrink-0">
                      {brands.map((logo, i) => (
                        <div
                          key={i}
                          className="h-20 w-28 md:h-24 md:w-36 bg-white rounded-xl flex items-center justify-center shadow-sm border border-gray-100"
                        >
                          <img
                            src={logo}
                            alt={`Brand ${i + 1}`}
                            className="max-h-16 md:max-h-20 object-contain"
                          />
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
              
              <div className="text-center mt-12">
                <button 
                  onClick={() => setIsPopupOpen(true)}
                  className="bg-black text-white px-8 py-3 rounded-full font-medium hover:bg-gray-800 transition-all shadow-md hover:shadow-lg inline-block cursor-pointer"
                >
                  View More
                </button>
              </div>
            </div>
          </section>
        </div>
      </section>

      {/* Full Screen Popup Modal */}
      <AnimatePresence>
        {isPopupOpen && (
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] bg-white overflow-y-auto"
          >
            <div className="min-h-screen relative pt-20 pb-16 px-6 lg:px-8">
              {/* Close Button */}
              <button 
                onClick={() => setIsPopupOpen(false)}
                className="absolute top-6 right-6 md:top-10 md:right-10 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-full p-3 transition-colors z-50 flex items-center justify-center cursor-pointer"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>

              <div className="max-w-7xl mx-auto">
                <div className="text-center mb-16">
                  <motion.h2 
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                    className="text-4xl md:text-5xl font-bold mb-4 text-gray-900"
                  >
                    Our Clients
                  </motion.h2>
                  <motion.p 
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    className="text-lg text-gray-600 max-w-2xl mx-auto"
                  >
                    We are proud to work with a diverse group of partners and organizations.
                  </motion.p>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-8">
                  {allClients.map((client, index) => (
                    <motion.div
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 0.4, delay: 0.2 + (index % 10) * 0.05 }}
                      key={index}
                      className="flex flex-col items-center justify-center p-6 bg-gray-50 rounded-2xl border border-gray-100 hover:shadow-lg transition-shadow h-48"
                    >
                      <div className="h-20 flex items-center justify-center mb-4 w-full">
                        {client.logo ? (
                          <img src={client.logo} alt={client.name} className="max-h-full max-w-full object-contain mix-blend-multiply" />
                        ) : (
                          <div className="text-gray-400 font-semibold text-center text-sm px-2">
                            {client.name}
                          </div>
                        )}
                      </div>
                      <h3 className="text-center font-medium text-sm text-gray-800 line-clamp-2">{client.name}</h3>
                    </motion.div>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
